import { useContext } from "react";
import { Context } from "../context/DataContext";
import DashboardDR from "./DashboardDR";
// import DashboardUS from "./DashboardUS";
import Loading from "@shared/components/Loading";
import { UseLoansXcobrar } from "@shared/server/fetcher";
import useCustomerBlock from "@shared/hooks/useCustomerBlock";
import RenderDisabledCustomer from "@shared/components/RenderDisabledCustomer";
import NoInternetContent from "@shared/components/NoInternetContent";

const Dashboard = () => {
  const { state } = useContext(Context);
  const { user, route: stateRoute } = state;

  const { data: loans, isLoading } = UseLoansXcobrar(stateRoute.creditor_id, user.user_id);
  const block = useCustomerBlock(stateRoute?.user_id);

  if (isLoading || block.isChecking) return <Loading />;
  // Guarded even though it is read-only: this is where the app lands after login, so a
  // blocked owner meets the payment screen straight away instead of a working portfolio.
  if (block.isBlocked) return <RenderDisabledCustomer {...block.disabledProps} />;
  if (!loans) return <NoInternetContent />;

  // if (!lastFetch.debtors || !lastFetch.loans) return <FullLoadingScreen />;
  // return route.route_location === "2" ? <DashboardUS cuadre={cuadre} /> : <Dashboard1 loans={loans} />;
  return <DashboardDR loans={loans} />;
};

export default Dashboard;
